import { format } from 'date-fns';

import downloadXLS from 'utils/downloadXLS';
import { fetchAllIncentiveOfferEligibles } from 'modules/incentivesMarket/api/fetchAllIncentiveOfferEligibles';

import { buildIncentiveOfferEligiblesXlsxData } from './buildIncentiveOfferEligiblesXlsxData';
import { mapIncentiveOfferEligiblesToTableRows } from './mapIncentiveOfferEligiblesToTableRows';

const sanitizeFileName = (value: string) =>
  value
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-') || 'eligibles';

type DownloadIncentiveOfferEligiblesXlsxProps = {
  incentiveOfferId: string;
  societyId: string;
  offerReference: string;
  t: (key: string) => string;
};

export const downloadIncentiveOfferEligiblesXlsx = async ({
  incentiveOfferId,
  societyId,
  offerReference,
  t,
}: DownloadIncentiveOfferEligiblesXlsxProps) => {
  const items = await fetchAllIncentiveOfferEligibles({
    incentiveOfferId,
    societyId,
  });

  const eligibles = mapIncentiveOfferEligiblesToTableRows({
    items,
    societyId,
  });

  const xlsxData = buildIncentiveOfferEligiblesXlsxData({ eligibles, t });
  const fileName = `${sanitizeFileName(offerReference)}-${sanitizeFileName(
    t('EligibleBeneficiaries')
  )}.xlsx`;

  downloadXLS(xlsxData, fileName, format(new Date(), 'yyyy-MM-dd'));
};
